var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiselect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 29.248,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 220,
    height: 70
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 159.844,
    y1: 29.248,
    x2: 159.844,
    y2: 99.248
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 198.187,86.416 221.077,46.769 175.297,46.769  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 99.248,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 143,
    height: 127.503
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.564,
    y: 121.116,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.91,
    height: 35.91
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.564,
    y: 172.116,
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 35.91,
    height: 35.91
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 93.5,
    y1: 139.071,
    x2: 138.31,
    y2: 139.071
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#128ABC",
      strokeWidth: 5.334,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 93.5,
    y1: 191.071,
    x2: 138.31,
    y2: 191.071
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselect);
export default __webpack_public_path__ + "static/media/multiselect.4e8ca2357a568194e160b07fc0f09efd.svg";
export { ForwardRef as ReactComponent };